export default (() => {

    const isXLDesktop = window.innerWidth >= 1280;
    const isDesktop = window.innerWidth >= 1024 && window.innerWidth < 1280;
    const isDesktopOrGreater = isDesktop || isXLDesktop;
    const isTablet = window.innerWidth >= 768 && window.innerWidth < 1024;
    const isMobile = window.innerWidth < 768;

    return {
        isXLDesktop,
        isDesktop,
        isDesktopOrGreater,
        isTablet,
        isMobile
    }
})();